/**
 * @Author: Alex Sorafumo <Yuion>
 * @Date:   19/09/2016 1:51 PM
 * @Email:  alex@yuion.net
 * @Filename: img-crop.component.ts
 * @Last modified by:   Yuion
 * @Last modified time: 15/12/2016 11:30 AM
 */

import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, OnChanges } from '@angular/core';
import { DropService } from '../../../services/drop-service/drop-service.service';

import 'cropperjs';

declare let Cropper: any;

@Component({
    selector: 'img-crop',
    template: `<!--
@Author: Alex Sorafumo <Yuion>
@Date:   19/09/2016 12:34 PM
@Email:  alex@yuion.net
@Filename: img-crop.template.html
@Last modified by:   Yuion
@Last modified time: 15/12/2016 11:30 AM
-->

<div class="aca img-crop" widget>
    <div class="img-space">
        <div class="image">
            <div class="drop-zone" [class.hide]="model.image_data">
                <input *ngIf="select" name="imgfile" class="img-select" type="file" [file-stream]="'img-crop' + (id !== '' ? '-' + id: '')"
                />
                <label for="imgfile" drop-target [stream]="'img-crop' + (id !== '' ? '-' + id: '')" indicate="hover">
                    <div class="text">
                        Drop image<br>or<br>Click to select
                    </div>
                    <div class="icon upload"></div>
                </label>
            </div>
            <div class="cropper" *ngIf="model.image_data">
                <img #image class="image-display" [src]="model.image_data">
            </div>
            <div class="img-error" *ngIf="model.error"> File selected is not a valid image file</div>
        </div>
        <div class="overlay">
            <div class="loading img" *ngIf="model.saving">
                <img [src]="model.data.image">
                <br/>
            </div>
            <div class="loading" *ngIf="model.loading">
                <spinner type="dot-circle"></spinner>
            </div>
            <div class="save-container">
                <div class="save-btn" [class.show]="model.image_data" (mousedown)="saveImage()">
                    <div class="icon save"></div>
                </div>
            </div>
        </div>
    </div>
</div>`,
    styles: [`.img-crop{font-size:16px;padding:.5em;position:relative;text-align:center}.loading{font-size:1em;left:50%;position:absolute;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.loading.save{background-color:#fff;border-radius:.1em;-webkit-box-shadow:0 0 1px 1px rgba(0,0,0,.54);box-shadow:0 0 1px 1px rgba(0,0,0,.54);color:rgba(0,0,0,.87);padding:.5em 1em;top:15%;white-space:nowrap}.drop-zone{background-color:rgba(0,0,0,.2);border-radius:3px;font-size:1.6em;height:100%;white-space:nowrap;width:100%}.drop-zone .material-icons{font-size:1.5em}.drop-zone.hover{background-color:rgba(0,0,0,.54);opacity:1;z-index:200}.img-select{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}.hide{opacity:0;z-index:-1}.img-select+label{font-size:1em;color:#fff;width:100%;height:100%;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.img-select+label .icon{font-size:1.5em}.img-select+label.hover,.img-select+label:hover,.img-select:focus+label{background-color:rgba(0,0,0,.2)}.cropper,.image-display{position:absolute;top:0;left:0;right:0;bottom:0;pointer-events:none;z-index:100}.image-display{background-position:center;background-size:contain;background-repeat:no-repeat;-o-object-fit:contain;object-fit:contain;width:100%;height:100%}.img-space{border-radius:4px;display:inline-block;height:300px;width:300px;position:relative;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12)}.img-space .image{height:100%;width:100%;overflow:hidden;border-radius:4px;background-color:rgba(255,255,255,.54)}.img-space .overlay{position:absolute;top:0;left:0;right:0;bottom:0;pointer-events:none}.img-space .image-error{left:50%;max-width:75%;position:absolute;text-align:center;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.save-container{height:1.5em;width:1.4em;position:absolute;bottom:.5em;right:0;-webkit-transform:translateX(100%);transform:translateX(100%);font-size:2em;overflow:hidden}.save-btn{position:absolute;top:4px;left:0;right:4px;bottom:4px;border-radius:0 .2em .2em 0;background-color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-transform:translateX(-100%);transform:translateX(-100%);-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);-webkit-transition:background-color .3s,-webkit-transform .3s;transition:background-color .3s,transform .3s,-webkit-transform .3s;pointer-events:auto}.save-btn.show{-webkit-transform:translateX(0);transform:translateX(0)}.save-btn:hover{background-color:#81c784}.icon{height:1em;width:1em;background-position:center;background-size:contain;background-repeat:no-repeat}.icon.save{background-image:url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMDAwMDAwIiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KICAgIDxwYXRoIGQ9Ik0xNyAzSDVjLTEuMTEgMC0yIC45LTIgMnYxNGMwIDEuMS44OSAyIDIgMmgxNGMxLjEgMCAyLS45IDItMlY3bC00LTR6bS01IDE2Yy0xLjY2IDAtMy0xLjM0LTMtM3MxLjM0LTMgMy0zIDMgMS4zNCAzIDMtMS4zNCAzLTMgM3ptMy0xMEg1VjVoMTB2NHoiLz4KPC9zdmc+)}.icon.save.white{background-image:url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjRkZGRkZGIiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KICAgIDxwYXRoIGQ9Ik0xNyAzSDVjLTEuMTEgMC0yIC45LTIgMnYxNGMwIDEuMS44OSAyIDIgMmgxNGMxLjEgMCAyLS45IDItMlY3bC00LTR6bS01IDE2Yy0xLjY2IDAtMy0xLjM0LTMtM3MxLjM0LTMgMy0zIDMgMS4zNCAzIDMtMS4zNCAzLTMgM3ptMy0xMEg1VjVoMTB2NHoiLz4KPC9zdmc+)}.icon.upload{background-image:url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjRkZGRkZGIiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KICAgIDxwYXRoIGQ9Ik05IDE2aDZ2LTZoNGwtNy03LTcgN2g0em0tNCAyaDE0djJINXoiLz4KPC9zdmc+)}`],
})
export class ImageCropComponent implements OnChanges {
    @Input() public id  = 'zero';
    @Input() public circle = false;
    @Input() public file: any = null;
    @Input() public select = true;
    @Input() public ratio = '4:3';
    @Input() public width = 400;

    @Output() public saved = new EventEmitter();

    public model: any = {
        image: null,
        data: {},
        zoom: 100
    };

    @ViewChild('image') private image: ElementRef;

    private stream: any = null;
    private sub: any = null;

    constructor(private drop_service: DropService) {
        this.setupSize();
        this.model.data = {};
    }

    public ngOnChanges(changes: any) {
        if (changes.file) {
            this.loadImage(this.file);
        }
        if (changes.width || changes.ratio) {
            this.setupSize();
        }
    }

    public ngAfterViewInit() {
        if (this.id === '') {
            this.id = 'zero';
        }
        if (!this.stream) {
            this.stream = this.drop_service.getStream('img-crop' + (this.id !== '' ? '-' + this.id : ''));
        }
        this.sub = this.stream.subscribe((obj: any) => {
            if (obj.data && obj.event === 'drop') {
                obj.data.promise.then((data: any) => {
                    // At this point all file data has been collected
                    this.loadImage(data.files[0]);
                }, (err: any) => null);
            }
        });
    }
    /**
     * Sets up the size of the cropped image
     * @return
     */
    public setupSize() {
        const ratio: { x: any, y: any } = { x: this.ratio.split(':')[0], y: this.ratio.split(':')[1] };
    }
    /**
     * Loads the image and injects it into the image cropper component
     * @param Image file from file input field
     * @return
     */
    public loadImage(file: File) {
        if (!file) { return; }
        this.model.loading = true;
        this.model.image = new Image();
        const myReader: FileReader = new FileReader();
        myReader.onloadend = (loadEvent: any) => {
            this.model.image.src = loadEvent.target.result;
            this.model.image_data = loadEvent.target.result;
            this.setupCropper();
            setTimeout(() => {
                this.setImage(this.image);
                this.model.loading = false;
            }, 20);
        };
        myReader.readAsDataURL(file);
    }

    public setImage(img: any) {
        return;
    }
    /**
     * Emits the cropped image data.
     * @return
     */
    public saveImage() {
        this.model.saving = true;
        this.saved.emit(this.model.data.image);
        setTimeout(() => this.model.saving = false, 100);
    }

    public ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }

    private setupCropper() {
        if (this.image && this.image.nativeElement) {
            const ratio: { x: any, y: any } = { x: this.ratio.split(':')[0], y: this.ratio.split(':')[1] };
            this.model.cropper = new Cropper(this.image.nativeElement, { aspectRatio: ratio.x / ratio.y });
        }
    }
}
